// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"e19cbf9e","565":"7aca1e73","579":"897220c5","671":"490359a1","876":"31d6cfe0","936":"15c53c02"}[chunkId] + ".chunk.css";
};